import React from 'react';

/** Fine diamond lattice with a few connected nodes — the brand's background motif. Decorative only. */
export function GeometricField({
  className = ''
}: {
  className?: string;
}) {
  return <svg className={`pointer-events-none absolute inset-0 h-full w-full ${className}`} viewBox="0 0 1200 600" preserveAspectRatio="xMidYMid slice" aria-hidden="true" data-id="element-573" data-mp="u6my8a00lt48">
      <defs data-id="element-574" data-mp="z3v8loex8sux">
        <pattern id="cts-lattice" width="80" height="80" patternUnits="userSpaceOnUse" data-id="element-575" data-mp="145ca9m58cjck">
          <path d="M40 0 L80 40 L40 80 L0 40 Z" fill="none" stroke="#ffffff" strokeOpacity="0.05" strokeWidth="1" data-id="element-576" data-mp="143hu0l4wlfet" />
        </pattern>
      </defs>
      <rect width="1200" height="600" fill="url(#cts-lattice)" data-id="element-577" data-mp="1dw6vqoanjewy" />
      <g stroke="#C9A96E" strokeOpacity="0.35" strokeWidth="1" data-id="element-578" data-mp="1hwhbgso8xjp0">
        <line x1="880" y1="120" x2="1000" y2="200" data-id="element-579" data-mp="1hvxq11ze0d68" />
        <line x1="1000" y1="200" x2="960" y2="360" data-id="element-580" data-mp="1mwlhforj2w0z" />
        <line x1="1000" y1="200" x2="1120" y2="160" data-id="element-581" data-mp="1mtpko3rf2de4" />
        <line x1="960" y1="360" x2="1080" y2="440" data-id="element-582" data-mp="1ru3qdf5jpb8z" />
        <line x1="880" y1="120" x2="760" y2="240" data-id="element-583" data-mp="1rskbnszjf89b" />
      </g>
      <g fill="#C9A96E" data-id="element-584" data-mp="1qhygloca0b4j">
        <circle cx="880" cy="120" r="3" data-id="element-585" data-mp="1qf2io00fhmg3" />
        <circle cx="1000" cy="200" r="4.5" data-id="element-586" data-mp="1lhkj308awjkr" />
        <circle cx="960" cy="360" r="3" data-id="element-587" data-mp="1lgr97qe1pdye" />
        <circle cx="1120" cy="160" r="2.5" fillOpacity="0.7" data-id="element-588" data-mp="1hg7bolpk88bq" />
        <circle cx="1080" cy="440" r="2.5" fillOpacity="0.7" data-id="element-589" data-mp="1hgqt81basup8" />
        <circle cx="760" cy="240" r="2.5" fillOpacity="0.7" data-id="element-590" data-mp="1cifna1o4j4ca" />
      </g>
    </svg>;
}